import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CLIENTS_LIST_KEY } from 'modules/client/management/constants';
import { ClientService } from 'modules/client/management/services';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteClient = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('client');
  return useMutation(() => ClientService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([CLIENTS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
